import { cn } from '@/lib/cn';
import { type TextareaHTMLAttributes, forwardRef } from 'react';

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      'w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-foreground',
      'placeholder:text-foreground-muted',
      'focus-visible:outline-none',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      'font-mono leading-relaxed',
      className,
    )}
    {...props}
  />
));
Textarea.displayName = 'Textarea';
